module.exports = __webpack_public_path__ + "assets/img/tech-14.46d11603.svg";